import React from 'react';
import { Text, makeStyles, tokens, Button, mergeClasses } from '@fluentui/react-components';
import { EntitySelectionWarningIcon } from './media/icons';

const useEntitySelectionErrorViewStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: '16px',
    maxHeight: '240px',
    overflow: 'hidden',
  },
  title: {
    marginTop: '4px',
    marginBottom: '4px',
    fontWeight: tokens.fontWeightBold,
    color: tokens.colorNeutralForeground1,
  },
  description: {
    marginBottom: '8px',
    color: tokens.colorNeutralForeground3,
  },
  buttonText: {
    fontWeight: tokens.fontWeightRegular,
    color: tokens.colorNeutralForeground1,
  },
  button: {
    paddingRight: 0,
    paddingLeft: 0,
  },
  retryButton: {
    paddingRight: 0,
    paddingLeft: 0,
  },
});

interface EntitySelectionErrorViewProps {
  i18n: any;
  onRetry?: () => void;
}

export const EntitySelectionErrorView = (props: EntitySelectionErrorViewProps) => {
  const {
    i18n,
    onRetry,
  } = props;
  const styles = useEntitySelectionErrorViewStyles();

  return (
    <div className={mergeClasses(styles.root, 'entity-selection-error')}>
      <EntitySelectionWarningIcon />
      <Text size={300} className={mergeClasses(styles.title, 'copilot-no-results-title')}>
        {i18n.getString(_TL_('Failed to load.'))}
      </Text>
      <Text size={100} className={mergeClasses(styles.description, 'copilot-no-results-description')}>
        {i18n.getString(_TL_('Please try again.'))}
      </Text>
      <Button onClick={onRetry} className={mergeClasses(styles.retryButton, 'error-retry-button')}>
        <Text size={200} className={styles.buttonText}>
          {i18n.getString(_TL_('Try again'))}
        </Text>
      </Button>
    </div>
  );
};
